import { render, staticRenderFns } from "./TableFooter.vue?vue&type=template&id=296a495d&scoped=true"
import script from "./TableFooter.vue?vue&type=script&lang=js"
export * from "./TableFooter.vue?vue&type=script&lang=js"
import style0 from "./TableFooter.vue?vue&type=style&index=0&id=296a495d&prod&lang=scss"
import style1 from "./TableFooter.vue?vue&type=style&index=1&id=296a495d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296a495d",
  null
  
)

export default component.exports